import { React, useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
} from "../../styledElements";
import { Button, PageHeader, Table, Tooltip } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import { Styled } from "../../pageStyled";
import {
  paperMachineListDataForConfiguration,
  searchMachines,
  getFilteredMachines,
} from "../../../Services/machineServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import moment from "moment";
// import { getMachineGradeSelect } from "../../../Services/settingsServices";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import EmptyState from "../../../Components/EmptyState/emptyState";
import {
  currency_List,lengthUnit,weightUnit 
  } from "../../../Utils/Constant/MeasurementUnitList.jsx";

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const MachineRecordsData = (props) => {
  const location = useLocation();
  const history = useNavigate();
  const [addToaster, setAddToaster] = useState(
    location.state?.action === "add"
  );
  const [deleteToaster, setDeleteToaster] = useState(
    location.state?.action === "delete"
  );
  const [machineRecords, setMachineRecords] = useState([]);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [totalRecords, setTotalRecords] = useState();
  const [tableParams, setTableParams] = useState({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10,
  });
  const paginationRef = useRef({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [exportRecords, setExportRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [rendering, setRendering] = useState(false);

  const titleRef = useRef(null);
  const [stickyOffsets, setStickyOffsets] = useState({ title: 58, table: 100 });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const baseTop = 58;
      const titleHeight = titleRef.current?.offsetHeight || 0;

      setStickyOffsets({
        title: baseTop,
        table: baseTop + titleHeight
      });
    });

    if (titleRef.current) observer.observe(titleRef.current);

    return () => observer.disconnect();
  }, [rendering]);

  const columnsHead = useRef ( [
    {
      title: "Machine Code",
      dataIndex: "code",
      width: "9%",
      sorter: {
        compare: (a, b) => a.code - b.code,
      },
      fixed: "left",
      align: "left",
    },
    {
      title: "Machine Name",
      dataIndex: "name",
      width: "9%",
      fixed: "left",
    },
    {
      title: "GSM Range",
      dataIndex: "gsm_range",
      width: "7%",
    },
    {
      title: "Width Range",
      dataIndex: "width_range",
      width: "8%",
    },
    {
      title: "Prod.Capacity",
      dataIndex: "production_capacity",
      width: "10%",
      render: (text) => `${text}`,
    },
    // {
    //   title: "Max Cutters",
    //   dataIndex: "maximum_cutters",
    //   width: "7%",
    // },
    // {
    //   title: "Max Waste",
    //   dataIndex: "maximum_waste",
    //   width: "6%",
    //   render: (text) => `${text} %`,
    // },
    {
      title: "Order Types",
      dataIndex: "order_type",
      width: "7%",
      render: (text) => (text === "both" ? "Reels, Sheets" : capitalize(text)),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      width: "8%",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "5%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Active"
                  ? "This machine can be used for deckle matching and production."
                  : record.status === "Disabled"
                  ? "This machine is currently disabled and cannot be used for deckle match."
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "8%",
      align: "center",
      render: (text, record) => (
        <div className="actionBtn">
          {userDetails.roles.machine_records.edit && (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Edit this machine"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => handleEdit(record)}>
                  <Iconmoon icon="edit" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this machine"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => handleView(record)}>
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
    },
  ]);
  
  const refresh  = () => {
    setLoading(true);
    setMachineRecords();
    setSearchValue("");
    setClearSearch(true);
    setRendering(true);
  }

  // useEffect(() => {
  //   setLoading(true);
  //   if(rendering && !appliedFilters.length && searchValue == "") {
  //     fetchMachineRecords(paginationRef.current);
  //     setRendering(false);
  //   } else if(!appliedFilters.length && searchValue == "") {
  //     fetchMachineRecords(paginationRef.current);
  //    // return () => setMachineRecords([]);
  //   }
  // }, [tableParams, rendering]);

  useEffect(() => {
    setLoading(true);
    if (appliedFilters.length) {
      fetchFilteredMachines();
    } else if ( !appliedFilters.length && searchValue !== "") {
      searchMachines(searchValue, paginationRef.current)
        .then((response) => {
          setLoading(false);
          setEmptyStateLabel("search");
          const formattedRecords = response.machines.map((machine) => {
            return {
              code: machine.code,
              name: machine.name,
              gsm_range: `${machine.minimum_gsm} - ${machine.maximum_gsm}`,
              width_range: `${machine.minimum_width} - ${machine.maximum_width} ${lengthUnit[ machine.units?.maximum_width]?.displayName.toUpperCase()}`,
              production_capacity: machine.production_capacity + ' ' + capitalize(weightUnit[machine.units.production_capacity]?.displayName),
              maximum_cutters: machine.maximum_cutters,
              maximum_waste:
                machine.maximum_waste != 0
                  ? machine.maximum_waste.toFixed(2)
                  : machine.maximum_waste,
              order_type: machine.order_type,
              status: machine.status === "active" ? "Active" : "Disabled",
              createdDate: moment(machine.created_at).format("DD MMM YYYY"),
            };
          });
          setMachineRecords(formattedRecords);
          setTotalRecords(response.total_machines);
        })
        .catch((error) => 
          console.log("Error in searching machines:", error),
          setEmptyStateLabel("connectionAPIError")
        );
    } else {
      fetchMachineRecords(paginationRef.current);
    }
  }, [appliedFilters, tableParams, searchValue,rendering]);

  const fetchFilteredMachines = () => {
   
    getFilteredMachines(paginationRef.current, appliedFilters, undefined, searchValue)
      .then((response) => {
        setLoading(false);
        setEmptyStateLabel("filter");
        const filteredList = response.data.machines.map((machine) => {
          return {
            code: machine.code,
            name: machine.name,
            gsm_range: `${machine.minimum_gsm} - ${machine.maximum_gsm}`,
            width_range: `${machine.minimum_width} - ${machine.maximum_width} ${lengthUnit[ machine.units.maximum_width]?.displayName.toUpperCase()}`,
            production_capacity: machine.production_capacity + ' ' + capitalize(weightUnit[machine.units.production_capacity]?.displayName),
            maximum_cutters: machine.maximum_cutters,
            maximum_waste:
              machine.maximum_waste != 0
                ? machine.maximum_waste.toFixed(2)
                : machine.maximum_waste,
            order_type: machine.order_type,
            createdDate: moment(machine.created_at).format("DD MMM YYYY"),
            status: machine.status === "active" ? "Active" : "Disabled",
          };
        });
        setMachineRecords(filteredList);
        setTotalRecords(response.data.total_machines);
      })
      .catch((error) => 
      console.log(error),
      setEmptyStateLabel("connectionAPIError"));
  };

  useEffect(() => {
    let propsData = {};
    if(emptyStateLabel === "noData"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] = "There are no records to show in this list. Add your first record to view details here";
    } else if(emptyStateLabel === "search"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if(emptyStateLabel === "filter"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] = "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  },[emptyStateLabel]);

  const exportHandler = () => {
    const currentDate = new Date();
    const today = (currentDate.getDate() + "/" + currentDate.toLocaleString("default", { month: "long" }) + "/" +  currentDate.getFullYear());
    let fileName = "Machine_Records_Kiaznn_"+today;
    if (appliedFilters.length) {
      history("../machine-records/export-machine", {
        state: {
          body: {
            appliedFilters: appliedFilters,
            page: "machine records",
            type: "Filter",
            searchValue: searchValue
          },
          rootPage: "../machine-records",
          fileName: fileName,
        },
      });
    } else if(!clearSearch && searchValue){
      let params = {
        sort_by: "created_at",
        sort_type: "descending",
      }
      history("../machine-records/export-machine", {
          state: {
            body: {
              searchValue: searchValue,
              params: params,
              page: "machine records",
              type: "Search"
            },
            rootPage: "../machine-records",
            fileName: fileName,
          },
      });
    } else {
      history("../machine-records/export-machine", {
        state: {
          body: {
            page: "machine records",
            type: "All Data"
          },
          rootPage: "../machine-records",
          fileName: fileName,
        },
      });
    }
  };

  function onChange(pagination, filters, sorter, extra) {
    setMachineRecords([]);
    setLoading(true);
    columnsHead.current?.map((item) => {
      if(item.dataIndex !== sorter?.field){
        item["sortOrder"] = null;
      } 
      if (item.dataIndex == sorter?.field) {
        item["sortOrder"] = sorter ? sorter.order : "";
      }
    });
    const tempSort = sorter.order === "ascend" ? "ascending" : "descending";
    if (
      sorter.field &&
      (paginationRef.current.sort_type !== tempSort)
    ) {
      setClearSearch(true);
      setCurrentPage(1);
      setTableParams({
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      });
      paginationRef.current = {
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      };
    } else {
      setClearSearch(true);
      setCurrentPage(pagination.current);
      setTableParams({
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.order ? sorter.field : "created_at",
        sort_type: tempSort,
      });
      paginationRef.current = {
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.order ? sorter.field : "created_at",
        sort_type: tempSort,
      };
    }
  }

  const fetchMachineRecords = async (params) => {
    try {
      const records = await paperMachineListDataForConfiguration(params);
      if(!records.machines.length){
        setEmptyStateLabel("noData");
      }
      const formattedRecords = records.machines.map((machine) => {
        return {
          code: machine.code,
          name: machine.name,
          gsm_range: `${machine.minimum_gsm} - ${machine.maximum_gsm}`,
          width_range: `${machine.minimum_width} - ${machine.maximum_width} ${lengthUnit[ machine.units.maximum_width]?.displayName.toUpperCase()}`,
          production_capacity: machine.production_capacity + ' ' + capitalize(weightUnit[machine.units.production_capacity]?.displayName),
          maximum_cutters: machine.maximum_cutters,
          maximum_waste:
            machine.maximum_waste != 0
              ? machine.maximum_waste.toFixed(2)
              : machine.maximum_waste,
          order_type: machine.order_type,
          createdDate: moment(machine.created_at).format("DD MMM YYYY"),
          status: machine.status === "active" ? "Active" : "Disabled",
        };
      });
      setMachineRecords(formattedRecords);
      setTotalRecords(records.total_machines);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("Error in fetching machine records", err);
      setLoading(false);
      setEmptyStateLabel("connectionAPIError");
    }
  };

  const searchMach = async (value = "") => {
    setMachineRecords([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
  });
    setLoading(true);
    setSearchValue(value);
  };

  const routeChange = () => {
    history("../add-new-machine");
  };

  const handleEdit = (record) => {
    history("../edit-machine", {
      state: { machineCode: record.code, action: "edit" },
    });
  };

  const handleView = (record) => {
    history("../edit-machine", {
      state: {
        machineCode: record.code,
        action: "view",
        roles: userDetails.roles.machine_records,
      },
    });
  };

  const applyfilter = (filter) => {
    setMachineRecords([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
  });
    setCurrentPage(1);
    
    paginationRef.current = {
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }
    let temp = appliedFilters;
    let alreadySetFilter = false;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setFilterTags(tempVar.map(formatFilters));
    setTableParams( (prevState) => ({
      ...prevState,
      page: 1,
      size: 10,
     
    }));
  };

  const formatFilters = (item) => {
    switch (item.type) {
      case "min_gsm":
        let minGsmOperand = "";
        let minGsmValue = "";
        if (item.operator === "in_range") {
          minGsmOperand = "between";
          minGsmValue = `${item.min_gsm_range} and ${item.max_gsm_range}`;
        } else if (item.operator === "equal_to") {
          minGsmOperand = "equals";
          minGsmValue = `${item.min_gsm}`;
        } else if (item.operator === "equal_to") {
          minGsmOperand = "equals";
          minGsmValue = `${item.min_gsm}`;
        } else if (item.operator === "less_than") {
          minGsmOperand = "less than";
          minGsmValue = `${item.min_gsm}`;
        } else {
          minGsmOperand = "greater than";
          minGsmValue = `${item.min_gsm}`;
        }
        return {
          type: item.type,
          formattedType: "Min.GSM",
          operand: minGsmOperand,
          value: minGsmValue,
        };
      case "max_gsm":
        let maxGsmOperand = "";
        let maxGsmValue = "";
        if (item.operator === "in_range") {
          maxGsmOperand = "between";
          maxGsmValue = `${item.max_gsm_start} and ${item.max_gsm_end}`;
        } else if (item.operator === "equal_to") {
          maxGsmOperand = "equals";
          maxGsmValue = `${item.max_gsm}`;
        } else if (item.operator === "less_than") {
          maxGsmOperand = "less than";
          maxGsmValue = `${item.max_gsm}`;
        } else {
          maxGsmOperand = "greater than";
          maxGsmValue = `${item.max_gsm}`;
        }
        return {
          type: item.type,
          formattedType: "Max.GSM",
          operand: maxGsmOperand,
          value: maxGsmValue,
        };
      case "min_deckle_width":
        let minDeckOperand = "";
        let minDeckValue = "";
        if (item.operator === "in_range") {
          minDeckOperand = "between";
          minDeckValue = `${item.min_deckle_width} and ${item.max_deckle_width}`;
        } else if (item.operator === "equal_to") {
          minDeckOperand = "equals";
          minDeckValue = `${item.deckle_width}`;
        } else if (item.operator === "less_than") {
          minDeckOperand = "less than";
          minDeckValue = `${item.deckle_width}`;
        } else {
          minDeckOperand = "greater than";
          minDeckValue = `${item.deckle_width}`;
        }
        return {
          type: item.type,
          formattedType: "Min. Deckle Width",
          operand: minDeckOperand,
          value: minDeckValue,
        };
      case "max_deckle_width":
        let maxDeckOperand = "";
        let maxDeckValue = "";
        if (item.operator === "in_range") {
          maxDeckOperand = "between";
          maxDeckValue = `${item.min_deckle_width} and ${item.max_deckle_width}`;
        } else if (item.operator === "equal_to") {
          maxDeckOperand = "equals";
          maxDeckValue = `${item.deckle_width}`;
        } else if (item.operator === "less_than") {
          maxDeckOperand = "less than";
          maxDeckValue = `${item.deckle_width}`;
        } else {
          maxDeckOperand = "greater than";
          maxDeckValue = `${item.deckle_width}`;
        }
        return {
          type: item.type,
          formattedType: "Max. Deckle Width",
          operand: maxDeckOperand,
          value: maxDeckValue,
        };
      case "production_capacity":
        let prodCapOperand = "";
        let prodCapValue = "";
        if (item.operator === "in_range") {
          prodCapOperand = "between";
          prodCapValue = `${item.min_production_capacity} and ${item.max_production_capacity}`;
        } else if (item.operator === "equal_to") {
          prodCapOperand = "equals";
          prodCapValue = `${item.production_capacity}`;
        } else if (item.operator === "less_than") {
          prodCapOperand = "less than";
          prodCapValue = `${item.production_capacity}`;
        } else {
          prodCapOperand = "greater than";
          prodCapValue = `${item.production_capacity}`;
        }
        return {
          type: item.type,
          formattedType: "Production Capacity",
          operand: prodCapOperand,
          value: prodCapValue,
        };
      case "maximum_waste":
        let maxWasteOperand = "";
        let maxWasteValue = "";
        if (item.operator === "in_range") {
          maxWasteOperand = "between";
          maxWasteValue = `${item.min_maximum_waste} and ${item.max_maximum_waste}`;
        } else if (item.operator === "equal_to") {
          maxWasteOperand = "equals";
          maxWasteValue = `${item.maximum_waste}`;
        } else if (item.operator === "less_than") {
          maxWasteOperand = "less than";
          maxWasteValue = `${item.maximum_waste}`;
        } else {
          maxWasteOperand = "greater than";
          maxWasteValue = `${item.maximum_waste}`;
        }
        return {
          type: item.type,
          formattedType: "Maximum Waste",
          operand: maxWasteOperand,
          value: maxWasteValue,
        };
      case "order_type":
        const orderTypeValue =
          item.order_type === "both"
            ? `Reel/Sheet`
            : item.order_type === "reel"
            ? `Reel`
            : `Sheet`;
        return {
          type: item.type,
          formattedType: "Order Type",
          operand: "-",
          value: orderTypeValue,
        };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
      case "status":
        const formattedStatus =
          item.status === "both"
            ? `Active/Disabled`
            : item.status === "active"
            ? `Active`
            : `Disabled`;
        return {
          type: item.type,
          formattedType: "Status",
          operand: "-",
          value: formattedStatus,
        };
    }
  };

  const removeFilter = (filter) => {
    setMachineRecords([]);

    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
  });
    const filterList = appliedFilters.filter((item) => {
      return item.type !== filter.type;
    });
    const formattedFilterList = filterTags.filter((item) => {
      return item.type !== filter.type;
    });
    setFilterTags(formattedFilterList);
    setAppliedFilters(filterList);
    // setRendering(true);
    // setSearchValue("");
    // setClearSearch(true);
    setLoading(true);
    setCurrentPage(1);
    setTableParams( (prevState) => ({
      ...prevState,
      page: 1,
      size: 10,
     
    }));
    paginationRef.current = {
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    };
  };

    return (
      <RightLayoutContainer id="right-layout-container">
        <style dangerouslySetInnerHTML={{
          __html: `
          .ant-tabs, .ant-tabs-content-holder, .ant-tabs-content, .ant-tabs-tabpane {
            overflow: visible !important;
          }
          .ant-table-sticky-holder {
            z-index: 101 !important;
          }
          .tableDataFormat table colgroup col {
            min-width: 100px !important;
          }
        `}} />
        <PageTitleComp ref={titleRef} style={{ borderBottom: "0", position: "sticky", top: stickyOffsets.title, zIndex: 100, backgroundColor: "#fff", paddingBottom: "10px" }}>
          <PageHeader
          ghost={false}
          title="Paper Machine Records"
          extra={
            userDetails?.roles?.machine_records.edit && [
              <Button key="1" className="themeBtn" onClick={routeChange}>
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Add a new machine
              </Button>,
            ]
          }
        ></PageHeader>
      </PageTitleComp>
      <TableLayoutData>
        <div className="tableDataFormat">
          <SearchContainer
            placeholder={"Search machine code or machine name"}
            fetchOrder={searchMach}
            exportRole={machineRecords?.length ? true : false}
            exportTrigger={exportHandler}
            clearSearch={clearSearch}
            setClearSearch={setClearSearch}
            searchedValue={searchValue}
            filterOptions={[
              {
                key: 0,
                label: "Filter by Minimum GSM",
                value: "min_gsm",
                type: "inputSelect",
              },
              {
                key: 1,
                label: "Filter by Max GSM",
                value: "max_gsm",
                type: "inputSelect",
              },
              {
                key: 2,
                label: "Filter by Min Deckle Width",
                value: "min_deckle_width",
                type: "inputSelect",
                unitType : "length"
              },
              {
                key: 3,
                label: "Filter by Max Deckle Width",
                value: "max_deckle_width",
                type: "inputSelect",
                unitType : "length"
              },
              {
                key: 4,
                label: "Filter by Production Capacity",
                value: "production_capacity",
                type: "inputSelect",
                unitType : "weight"
              },
              {
                key: 5,
                label: "Filter by Order Type",
                value: "order_type",
                type: "multiSelect",
              },
              {
                key: 6,
                label: "Filter by Created date",
                value: "created_date",
                type: "date",
              },
              {
                key: 7,
                label: "Filter by Status",
                value: "status",
                type: "multiSelect",
              },
            ]}
            applyFilter={applyfilter}
          />
          {filterTags.map((filter) => (
            <span className="filter-tags">
              <Iconmoon icon="filter" size={13} color="#a8a8a8" />
              &nbsp;
              <span>{filter.formattedType}</span>
              &nbsp;
              <span>{filter.operand}</span>
              &nbsp;
              <span>{filter.value}</span>
              <span>
                {" "}
                <button
                  onClick={() => {
                    removeFilter(filter);
                  }}
                >
                  {" "}
                  <Iconmoon icon="wrong" size={15} color="#a8a8a8" />{" "}
                </button>
              </span>
            </span>
          ))}
          {loading ? (
                    <TableShimmer
                      header = {columnsHead.current}
                      scroll={{ x: window.screen.width < 1500 && 1460 }}
                    />
                  ) : machineRecords?.length ? (
          <Table
            columns={columnsHead.current}
            dataSource={machineRecords}
            onChange={onChange}
            pagination={{
              current: currentPage,
              total: totalRecords,
              showTitle: false,
              showSizeChanger: true,
              pageSize: paginationRef.current.size,
              showTotal: (total, range) =>
                `Showing ${range[0]}-${range[1]} of ${total} results`,
            }}
            scroll={{ x: "max-content" }}
            sticky={{
              offsetHeader: stickyOffsets.table,
              getContainer: () => {
                let node = document.getElementById('right-layout-container');
                while (node && node !== document.body) {
                  const style = window.getComputedStyle(node);
                  if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
                  node = node.parentNode;
                }
                return window;
              }
            }}
          />
          ) : (
            <EmptyState
              img= {emptyStateLabel === "noData" || emptyStateLabel === "filter" ? emptyState_NoData : 
              emptyStateLabel === "search" ? emptyState_Search : 
              emptyState_ConnectionAPIError}
              heading= {emptyStatePropsData.heading}
              subHeading= {emptyStatePropsData.subHeading}
              label={emptyStatePropsData.label}
              refresh={refresh}
              />
          )}
        </div>
      </TableLayoutData>

      {addToaster && (
        <AlertContainer
          closeIcon={true}
          setClose={setAddToaster}
          color={`${location.state.response.error ? "red" : "green"} toaster`}
          icon={location.state.response.error ? alertRed : alertGreen}
          msg={
            location.state.response.error
              ? location.state.response.msg
              : `A new machine ${location.state.response.data.name} is successfully added`
          }
        >
          {console.log(location.state.response)}
          {setTimeout(() => setAddToaster(false), 3000)}
        </AlertContainer>
      )}

      {deleteToaster && (
        <AlertContainer
          closeIcon={true}
          setClose={setDeleteToaster}
          color={`${location.state.response.error ? "red" : "green"} toaster`}
          icon={location.state.response.error ? alertRed : alertGreen}
          msg={
            location.state.response.error
              ? location.state.response.msg
              : `Machine is successfully deleted`
          }
        >
          {setTimeout(() => setDeleteToaster(false), 3000)}
        </AlertContainer>
      )}
    </RightLayoutContainer>
  );
};

export default MachineRecordsData;
